import script from "./AccountDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountDetails.vue?vue&type=script&setup=true&lang=js"

import "./AccountDetails.vue?vue&type=style&index=0&id=66898298&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66898298"]])

export default __exports__